module.exports = __webpack_public_path__ + "static/media/dog-footprints2.043346ab.svg";